module.exports = __webpack_public_path__ + "img/ab75dab.jpg";